import { Theme } from '@mui/material';

export const getCalculatorSelectStyles = () => ({
  MenuProps: {
    PaperProps: {
      sx: {
        borderRadius: 2,
        boxShadow: 3,
        mt: 1,
        backgroundColor: 'background.paper',
      },
    },
  },
});

export const getCalculatorAccordionStyles = (theme: Theme) => ({
  p: 0,
  border: `1px solid ${theme.palette.purple[500]}`,
  maxWidth: '100%',
  '&[class*="MuiAccordion-root"]': {
    borderRadius: '0.25rem',
  },
  '& [class*="MuiAccordionSummary-root"]': {
    textTransform: 'uppercase',
    color: `${theme.palette.purple[900]}CC`,
    fontWeight: 'normal',
  },
  '& [class*="MuiAccordionSummary-expandIconWrapper"] svg': {
    color: theme.palette.purple[500],
  },
  '& [class*="MuiAccordionSummary-content"]': {
    fontSize: theme.typography.medium.fontSize,
  },
  '& [class*="MuiAccordionSummary-root"] svg': {
    px: 0,
  },
  '& [class*="MuiAccordionSummary-content"] svg': {
    my: 0,
  },
  ' .MuiAccordionDetails-root': {
    maxWidth: '100%',
    overflow: 'auto',
  },
});

export const getCalculatorOutputAccordionStyles = (theme: Theme) => ({
  p: 0,
  background: `${theme.palette.purple[900]}95`,
  maxWidth: '100%',
  '&[class*="MuiAccordion-root"]': {
    borderRadius: '0.25rem',
  },
  '& [class*="MuiAccordionSummary-root"]': {
    textTransform: 'uppercase',
    color: `${theme.palette.common.white}CC`,
    fontWeight: 'normal',
    fontSize: theme.typography.medium.fontSize,
  },
  '& [class*="MuiAccordionSummary-expandIconWrapper"] svg': {
    color: `${theme.palette.common.white}CC`,
  },
  '& [class*="MuiAccordionSummary-root"] svg': {
    px: 0,
  },
  '& [class*="MuiAccordionSummary-content"] svg': {
    my: 0,
  },
  ' .MuiAccordionDetails-root': {
    maxWidth: '100%',
    overflow: 'auto',
    '*': {
      color: theme.palette.common.white,
    },
    table: {
      maxWidth: '100%',
      width: 'auto',
    },
    'thead, th': {
      background: 'transparent',
      fontSize: theme.typography.small.fontSize,
    },
    th: {
      whiteSpace: 'nowrap',
      width: '1%',
    },
    td: {
      fontSize: theme.typography.small.fontSize,
    },
  },
});

export const getCalculatorTitleStyles = () => ({
  display: 'flex',
  alignItems: 'baseline',
  justifyContent: 'center',
  flexWrap: 'wrap',
  gap: 1.5,
  mb: 2,
});

export const getCalculatorSummaryBoxStyles = () => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: {
    xs: 'stretch',
    md: 'space-between',
  },
  alignItems: 'stretch',
  maxWidth: '100%',
  gap: {
    xs: 2,
    md: 5,
  },
  mt: 2,
});

export const getCalculatorSummaryItemStyles = (theme: Theme) => ({
  borderRadius: 20,
  padding: 4,
  paddingBlock: 1.5,
  background: theme.palette.common.black,
  color: theme.palette.common.white,
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  flexGrow: 1,
  justifyContent: 'center',
  '&:nth-of-type(2)': {
    order: {
      md: 3,
      lg: 2,
    },
  },
});

export const getCalculatorDatePickerLabelStyles = (theme: Theme) => ({
  background: '#422570',
  color: theme.palette.common.white,
  borderRadius: 'calc(5 * var(--template-shape-borderRadius))',
  paddingInline: 'calc(1.75 * var(--template-spacing))',
  lineHeight: 1.5,
  fontSize: '1.15rem',
  paddingLeft: 'calc(2 * var(--template-spacing))',
  paddingRight: 'calc(2 * var(--template-spacing))',
  marginTop: 'calc(-4 * var(--template-spacing))',
  marginLeft: '0',
  textTransform: 'uppercase',
  textAlign: 'center',
});
